import React from 'react'

import EmojiObjectsIcon from '@material-ui/icons/EmojiObjects'
import HomeIcon from '@material-ui/icons/Home'
import InputIcon from '@material-ui/icons/Input'
import PersonIcon from '@material-ui/icons/Person'
import PhoneIcon from '@material-ui/icons/Phone'
import SimCardIcon from '@material-ui/icons/SimCard'
import WorkIcon from '@material-ui/icons/Work'

import { ReactComponent as LlamayaIconWhite } from '~/assets/llamaya-white.svg'
import { ReactComponent as LlamayaIcon } from '~/assets/llamaya.svg'
import { ReactComponent as MasmovilIconWhite } from '~/assets/masmovil-white.svg'
import { ReactComponent as MasmovilIcon } from '~/assets/masmovil.svg'
import { ReactComponent as YoigoIconWhite } from '~/assets/yoigo-white.svg'
import { ReactComponent as YoigoIcon } from '~/assets/yoigo.svg'

export type TechnologyValues = 'mobileOnly' | 'convergent' | '2p' | 'energy'
export type LineTypeValues = 'postpaid' | 'prepaid' | 'fixed'
export type SegmentValues = 'residential' | 'pro'
export interface Button {
  label: string
  icon: React.ReactNode
  value: TechnologyValues | LineTypeValues | SegmentValues
  disabled: boolean
}

interface BrandIcons {
  [key: string]: {
    icon: React.ReactNode
    iconSelected: React.ReactNode
  }
}

export const brandsIcons: BrandIcons = {
  yoigo: {
    icon: <YoigoIcon />,
    iconSelected: <YoigoIconWhite />,
  },
  masmovil: {
    icon: <MasmovilIcon />,
    iconSelected: <MasmovilIconWhite />,
  },
  llamaya: {
    icon: <LlamayaIcon />,
    iconSelected: <LlamayaIconWhite />,
  },
}

export const technologyButtons = [
  {
    label: 'Convergente (3P)',
    value: 'convergent',
    disabled: false,
    icon: (
      <div className="icon-wrapper">
        <HomeIcon />
        <SimCardIcon />
      </div>
    ),
  },
  {
    label: 'Sólo Móvil (1P)',
    value: 'mobileOnly',
    disabled: false,
    icon: <SimCardIcon />,
  },
  {
    label: 'Fijo + Internet (2P)',
    value: '2p',
    disabled: false,
    icon: (
      <div className="icon-wrapper">
        <PhoneIcon />
        <HomeIcon />
      </div>
    ),
  },
  {
    label: 'Energía',
    value: 'energy',
    disabled: false,
    icon: <EmojiObjectsIcon />,
  },
  {
    label: 'Leads',
    value: 'leads',
    disabled: false,
    icon: <InputIcon />,
  },
] as Button[]

export const lineTypeButtons = [
  {
    label: 'Pospago',
    value: 'postpaid',
    disabled: false,
    icon: <SimCardIcon />,
  },
  {
    label: 'Prepago',
    value: 'prepaid',
    disabled: false,
    icon: <SimCardIcon />,
  },
  {
    label: 'El Fijo',
    value: 'fixed',
    disabled: false,
    icon: <PhoneIcon />,
  },
] as Button[]

export const productButtons = [
  {
    label: 'Residencial',
    value: 'residential',
    disabled: false,
    icon: <PersonIcon />,
  },
  {
    label: 'Negocios',
    value: 'pro',
    disabled: false,
    icon: <WorkIcon />,
  },
] as Button[]
